import React from 'react';
import { Filter, FolderOpen } from 'lucide-react';

interface DocumentFiltersProps {
  onFilterChange: (filter: string) => void;
  onFolderChange: (folder: string) => void;
}

export default function DocumentFilters({ onFilterChange, onFolderChange }: DocumentFiltersProps) {
  return (
    <div className="flex items-center space-x-4">
      <select
        onChange={(e) => onFilterChange(e.target.value)}
        className="pl-3 pr-10 py-2 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="all">All Types</option>
        <option value="application/pdf">PDF</option>
        <option value="application/msword">Word</option>
        <option value="application/vnd.ms-excel">Excel</option>
        <option value="image">Images</option>
      </select>

      <select
        onChange={(e) => onFolderChange(e.target.value)}
        className="pl-3 pr-10 py-2 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="all">All Folders</option>
        <option value="financial">Financial</option>
        <option value="legal">Legal</option>
        <option value="contracts">Contracts</option>
        <option value="marketing">Marketing</option>
      </select>
    </div>
  );
}